import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import Popup from '../Popup';
import ButtonScogoPrimary from '../Buttons/ButtonScogoPrimary';
import ButtonScogoClosed from '../Buttons/ButtonScogoClosed';
import ButtonScogoClosedOutlined from '../Buttons/ButtonScogoClosedOutlined';

const TextModal = () => {
    const { heading, text, buttons, closeOnBackdropClick, formName } = useSelector((state) => state.modal);
    const { formButtonLoading } = useSelector((state) => state.loading);

    let buttonsUI = buttons.map((button, index) => {
        const buttonLookup = {
            red: ButtonScogoClosed,
            blue: ButtonScogoPrimary,
            redOutlined: ButtonScogoClosedOutlined,
        };

        const ButtonComponent = buttonLookup[button.type];

        return (
            <motion.div
                key={`text_modal_${index}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2, delay: index * 0.05 }}
            >
                <ButtonComponent
                    textOrComponent={button.textOrComponent}
                    onClick={button.onClick}
                    loading={button.showLoading ? formButtonLoading?.[formName] : false}
                    buttonClass={button.buttonClass}
                />
            </motion.div>
        );
    });

    return (
        <Popup closeOnBackdropClick={closeOnBackdropClick}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
            >
                <motion.p
                    className='text-font24 text-scogo30 mb-2 text-scogoprimary font-bold'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2, delay: 0.1 }}
                >
                    {heading}
                </motion.p>
                <motion.p
                    className='text-scogogray text-font16'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2, delay: 0.15 }}
                >
                    {text}
                </motion.p>
                <motion.div
                    className='gap-2 flex items-center justify-center mt-8'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2, delay: 0.2 }}
                >
                    {buttonsUI}
                </motion.div>
            </motion.div>
        </Popup>
    );
};

export default TextModal;
